<header class="position-absolute top-0 start-0 end-0 mt-3 mx-3">
    <div class="d-flex d-lg-none justify-content-center" *ngIf="isProduction">
        <a routerLink="/">
            <img class="w-100" [src]="logoPicSrc" alt="Image Description" data-hs-theme-appearance="default"
                style="min-width: 7rem; max-width: 8.5rem;">
        </a>
    </div>
</header>


<main id="content" role="main" class="main">
    <script type="text/javascript" async=""
        src="https://www.gstatic.com/recaptcha/releases/pCoGBhjs9s8EhFOHJFe8cqis/recaptcha__en.js"
        crossorigin="anonymous"
        integrity="sha384-ER8TR/9ygDDx6eY4PVNpeuj19NsI16UfPHQbL+Y1qWVn5fYv9C/Ki3MmObCWDrbd"></script>
    <script src="https://www.google.com/recaptcha/api.js" type="text/javascript"></script>

    <div class="container-fluid" style="padding-right: 1rem;padding-left: 0.5rem;">
        <div class="row">
  

            <div class="col-lg-6 d-flex justify-content-center align-items-center min-vh-lg-100">
                <div class="w-100 content-space-t-4 content-space-t-lg-2 content-space-b-1" style="max-width: 25rem;">

                    <form #myForm="ngForm" >
                        <input type="hidden" name="_csrf-frontend"
                            value="DEixXM0FXMMlQkvq4g3e8e_ZcvT72IZUS719ApMJXQlfcMcTpnYOhks0JZ6rYIqAhp0bo5-9xAQ-6TF2_X4XTA==">
                        <div class="text-center">
                            <div class="mb-5">
                                <h1 class="display-4">{{'createAccount'|translate}}</h1>
                                <p> {{'hasAccount'|translate}} <a class="link" routerLink="/{{mainPath}}/LoginPage">{{'loginHere'|translate}}</a> </p>
                            </div>
                        </div>

                        <div class="mb-4">
                            <label class="form-label" for="signupSrEmail">{{'nationality'|translate}}</label>

                            <div class="mb-3 field-signupform-nationality required text-end">
                                <select  class="form-select" name="nationality" required="true" [(ngModel)]="nationality" #nationality_field="ngModel">
                                    <option value="">{{'selectNat'|translate}}</option>
                                    <option value="1">{{'jordanian'|translate}}</option>
                                    <option value="2">{{'not-jordanian'|translate}}</option>
                                </select>
                                <span class="text-danger" *ngIf="myForm.submitted && !nationality_field.valid">{{'requiredField'|translate}}!</span>
                            </div>
                        </div>

                        <div class="row">
                            <div id="nationalId" class="col-sm-6">

                                <div class="mb-4">
                                    <label  class="form-label" for="signupSrEmail"> {{(nationality!='2' ?'nationalNumber':'personallNumber')|translate}}</label>
                                    <div class="mb-3 field-signupform-username">
                                        <input type="number"  [(ngModel)]="userName" #userName_field="ngModel" required="true" 
                                            class="form-control form-control-lg" name="userName" placeholder="{{(nationality!='2' ?'nationalNumber':'personallNumber')|translate}}" aria-required="true">
                                            <span class="text-danger" *ngIf="myForm.submitted && !userName_field.valid">{{'requiredField'|translate}}!</span>
                                    </div>
                                </div>

                            </div>
                            <div id="cardId" class="col-sm-6" *ngIf="nationality=='1'">

                                <div class="mb-4">
                                    <label class="form-label" >{{'IdCard'|translate}}</label>
                                    <div class="mb-3 field-signupform-national_cardid">
                                        <input type="text"  [(ngModel)]="idNumber" #idNumber_field="ngModel"
                                            class="form-control form-control-lg"  name="idNumber" [required]="nationality=='1'"
                                            placeholder="{{'IdCard'|translate}}">
                                            <span class="text-danger" *ngIf="myForm.submitted && !idNumber_field.valid">{{'requiredField'|translate}}!</span>

                                    </div>
                                </div>

                            </div>
                        </div>

                       

                        

                        <label class="form-label" for="signupSrEmail">{{'birthDate'|translate}}</label>
                        <div class="row">
                            <div class="col-sm-4">

                                <div class="mb-4">

                                    <div class="mb-3 field-signupform-birth_day">
                                        <select  [(ngModel)]="day" #day_field="ngModel" required="true"
                                            class="form-control form-control-lg form-select"
                                            name="day">
                                            <option value="">{{day|translate}}</option>
                                            <option *ngFor="let item of daysArr" value="{{item}}">{{item}}</option>
                                        </select>
                                        <span class="text-danger" *ngIf="myForm.submitted && !day_field.valid">{{'requiredField'|translate}}!</span>
                                    </div>
                                </div>

                            </div>
                            <div class="col-sm-4">

                                <div class="mb-4">

                                    <div class="mb-3 field-signupform-birth_month">
                                        <select id="signupform-birth_month" [(ngModel)]="month" #month_field="ngModel"
                                            class="form-control form-control-lg form-select" required="true"
                                            name="month" aria-required="true">
                                            <option value="">{{'month'|translate}}</option>
                                            <option *ngFor="let item of monthArr" value="{{item}}">{{item}}</option>
                                        </select>
                                        <span class="text-danger" *ngIf="myForm.submitted && !month_field.valid">{{'requiredField'|translate}}!</span>

                                    </div>
                                </div>

                            </div>
                            <div class="col-sm-4">

                                <div class="mb-4">

                                    <div class="mb-3 field-signupform-birth_year">
                                        <select [(ngModel)]="year" name="year" #year_field="ngModel"
                                            class="form-control form-control-lg form-select" required="true"
                                            >
                                            <option value="">{{'year'|translate}}</option>
                                            <option *ngFor="let item of yearsArr" value="{{item}}">{{item}}</option>

                                        </select>
                                        <span class="text-danger" *ngIf="myForm.submitted && !year_field.valid">{{'requiredField'|translate}}!</span>

                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="mb-4">
                            <label class="form-label" for="signupSrEmail">{{'email'|translate}}</label>

                            <input type="email" name="email" required="true" [(ngModel)]="email" #email_field="ngModel"
                                class="form-control form-control-lg" 
                                placeholder="{{'email'|translate}}">
                                <span class="text-danger" *ngIf="(myForm.submitted && !email_field.valid )|| showEmailRequeired">{{'requiredField'|translate}}!</span>
                        </div>

                        <div class="col-sm-12 mb-4">
                            <div class="wrapper" style="direction: ltr;">
                                <ngx-intl-tel-input
                                  [cssClass]="'form-control form-control-lg input-country-code'"
                                  [preferredCountries]="preferredCountries"
                                  [enableAutoCountrySelect]="true"
                                  [enablePlaceholder]="false"
                                  [searchCountryFlag]="true"
                                  [searchCountryField]="[
                                    SearchCountryField.Iso2,
                                    SearchCountryField.Name
                                  ]"
                                  [selectFirstCountry]="true"
                                  [selectedCountryISO]="CountryISO.Jordan"
                                  [phoneValidation]="false"
                                  [separateDialCode]="separateDialCode"
                                  [numberFormat]="PhoneNumberFormat.National"
                                  name="phoneNumber"
                                  [(ngModel)]="phoneNumber"
                                  [required]="true"
                                >

                                </ngx-intl-tel-input>

                              </div>

                              <span *ngIf="(phoneNumber==null && myForm.submitted)|| showPhoneRequeired" class="text-danger"  >

                                {{'requiredField'|translate}}

                            </span>
                              
                        </div>

                        <!-- <div class="mb-4">
                            <label class="form-label" for="signupSrEmail">رقم الهاتف</label>

                            <input type="text" name="phoneNumber" required="true" [(ngModel)]="phoneNumber" #phoneNumber_field="ngModel"
                                class="form-control form-control-lg" id="mobile"
                                placeholder="رقم الهاتف">
                                <span class="text-danger" *ngIf="(myForm.submitted && !phoneNumber_field.valid) || showPhoneRequeired">{{'requiredField'|translate}}!</span>

                        </div> -->

                        <div class="mb-4">
                            <label class="form-label" for="signupSremailOtp"> {{'email-check'|translate}} </label>

                            <div class="row">
                                <div class="col-9">
                                    <input type="email" name="emailOtp" required="true" [(ngModel)]="emailOtp" #emailOtp_field="ngModel"
                                    class="form-control form-control-lg" 
                                    placeholder="{{'email-check'|translate}}">
                                    <span class="text-danger" *ngIf="myForm.submitted && !emailOtp_field.valid">{{'requiredField'|translate}}!</span>
    
                                </div>
                                <div class="col-3">
                                    <button type="button" class="btn btn-primary" (click)="sendEmailOtp()" [disabled]="disableSendEmailBtn">{{'send'|translate}}</button>
                                </div>
                            </div>
                        </div>

                        <div class="mb-4">
                            <label class="form-label" for="signupSrEmail">{{'phone-check'|translate}}</label>

                            <div class="row">
                                <div class="col-9">
                                    <input type="text" name="phoneNumberOtp" required="true" [(ngModel)]="phoneNumberOtp" #phoneNumberOtp_field="ngModel"
                                    class="form-control form-control-lg" 
                                    placeholder="{{'phone-check'|translate}}">
                                    <span class="text-danger" *ngIf="myForm.submitted && !phoneNumberOtp_field.valid">{{'requiredField'|translate}}!</span>
    
                                </div>
                                <div class="col-3">
                                    <button  type="button" class="btn btn-primary" (click)="sendPhoneOtp()" [disabled]="disableSendPhoneBtn">{{'send'|translate}}</button>
                                </div>
                            </div>

                  
                        </div>

                        <!-- <input #phoneInput type="tel"> -->

                        <div class="mb-4">
                            <label class="form-label" for="signupSrEmail">{{'password'|translate}}</label>
                            <div class="mb-3 field-signupform-password">
                                <input type="password"  class="form-control form-control-lg"
                                name="password" required="true" [(ngModel)]="password" #password_field="ngModel"
                                    pattern="^(?=.*[A-Z])(?=.*[0-9])(?=.*[\W_]).{8,}$"
                                    placeholder="{{'password-hint'|translate}}" aria-required="true">
                                    <span class="text-danger" *ngIf="myForm.submitted && !password_field.valid">{{'requiredField'|translate}}!</span>

                                    <p class="text-danger" *ngIf="myForm.submitted && password_field?.errors?.['pattern']"> 
                                        {{'passwordComplexError'|translate}}  
                                    </p>

                                    
                            </div>
                        </div>
                        <div class="d-grid gap-2">
                            <button  class="btn btn-primary btn-lg" (click)="register()" >{{'createAccount'|translate}}</button>
                        </div>
                    </form>
                </div>
            </div>

            <div class="col-lg-6 d-none d-lg-flex justify-content-center min-vh-lg-100 position-relative px-0"
            style="background:url(../../../assets/images/signup-background.jpg) center;background-size:cover;">
            <div class="card pt-md-7 blur px-5 pb-10" *ngIf="isProduction"
                style="margin-top: 10.5rem;max-width: 23rem;max-height: 23rem;">
                <div class="text-center mb-5">
                    <img class="img-fluid" [src]="logoPicSrc" alt="Image Description" style="width: 12rem;" data-hs-theme-appearance="default">
                </div>
                <div class="mb-5">
                    <h2 class="display-5 text-center">
                        {{'investmentLoginDesc'|translate}}
                    </h2>
                </div>
            </div>
        </div>
        </div>

    </div>

</main>